import Pqp from "../../3x1010/Pqp.js";
import Game from "../Game.js";
import CellDesign from "./design/CellDesign.js";
import Maze from "./Maze.js";
import CellRender from "./render/CellRender.js";

export default class Cell {
	constructor(model, type, roomId, isStart = false, isEnd = false) {
		this.type = type;
		this.id = Cell.IDS++;
		this.start = isStart;
		this.end = isEnd;
		this.room = roomId;
		this.row = -1;
		this.col = -1;
		this.rowRoom = -1;
		this.colRoom = -1;
		this.deadEnd = false;
		this.shown = false;
		this.roomExits = new Array();
		this.sp = null;
		this.model = model;
		this._tiles = new Array();
		this.column = 0;
		this.locked = false;
		this.cellRender = null;
		this.torch = false;
		this.torchLit = false;
		this.animatedTiles = new Array();
		this.blocked = false;
		this.chest = false;
		this.booked = false;
		this.spiked = false;
		this.mobGenerated = null;
		this.furniture = null;
		this.furnitureUpper = false;
	}

	position() {
		return { top: this.row * Game.TILE_HEIGHT_MAP, left: this.col * Game.TILE_WIDTH_MAP };
	}

	isInView() {
		return this.shown;
	}

	isWall() {
		if (this.type === Cell.TYPE_WALL) {
			return true;
		}
		return false;
	}
	isColumn() {
		if (this.column > 0) {
			return true;
		}
		return false;
	}
	isChest() {
		return this.chest;
	}
	isSpike() {
		return this.spiked;
	}
	isProx() {
		let kind = this.spikeKind;
		if (kind === "prox") {
			return true;
		}
		return false;

	}

	isRoom() {
		if (this.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
			return true;
		}
		return false;
	}

	isSecretExit() {
		let exits = this.roomExits;
		let lSecret = false;
		for (let x = 0; x < exits.length; x++) {
			let room = exits[x];
			if (room.isSecret()) {
				lSecret = true;
				break;
			}
		}
		return lSecret;
	}
	isDoor() {
		if (this.isRoomExit()) {
			if (!this.isSecretExit()) {
				return true;
			}
		}
		return false;
	}

	isLockedDoor() {
		return this.locked;
	}

	lockDoor() {
		if (this.isDoor()) {
			this.locked = true;
		}
	}
	unlockDoor() {
		if (this.isDoor()) {
			this.locked = false;
		}
	}

	addAsRoomExit(room) {
		this.roomExits.push(room);
	}

	isRoomExit() {
		if (this.roomExits.length === 0) {
			return false;
		}
		return true;
	}

	isFireplace() {
		return this.fireplace;
	}

	isLightFireplace() {
		if (this.isFireplace()) {
			return this.mobGenerated.isLit();
		}
		return false;
	}


	isHorizontalDoor() {
		if (this.isRoomExit()) {
			if (!this.isSecretExit()) {
				let e = this.model.getNearbyCell(this, Maze.DIR_E);
				let w = this.model.getNearbyCell(this, Maze.DIR_W);
				if (e && w) {
					if (e.isWall() && w.isWall()) {
						return true;
					}
				}
			}
		}
		return false;
	}

	isHorizontalSecretExit() {
		if (this.isRoomExit()) {
			if (this.isSecretExit()) {
				let e = this.model.getNearbyCell(this, Maze.DIR_E);
				let w = this.model.getNearbyCell(this, Maze.DIR_W);
				if (e && w) {
					if (e.isWall() && w.isWall()) {
						return true;
					}
				}
			}
		}
		return false;
	}


	createTiles(sp) {
		this.sp = sp;
		this.cellRender = new CellRender(this, this.model, sp);
		this.cellRender.init();
	}

	hasTiles() {
		if (this.tiles.length === 0) {
			return false;
		}
		return true;
	}

	isDeadEnd() {
		return this.deadEnd;
	}

	hasTorch() {
		return this.torch;
	}

	isTorchLit() {
		return this.torchLit;
	}

	setTorchLit(lFlag) {
		for (let x = 0; x < this.animatedTiles.length; x++) {
			let ta = this.animatedTiles[x];
			if (ta.clas === "torch") {
				if (lFlag) {
					ta.setAnimation("lit");
				} else {
					ta.setAnimation("unlit");
				}
				this.torchLit = lFlag;
			}
		}

		if (lFlag) {
			this.cellRender.createTorchWall(this);
		}

	}
	isBlocked() {
		return this.blocked;
	}


	isFree() {
		if (!this.booked) {
			if (this.canWalk()) {
				if (!this.isChest()) {
					if (!this.isSpike()) {
						if (!this.mobGenerated) {
							return true;
						}
					}
				}
			}
		}

	}
	isNotImportant() {
		if (this.isWall()) {
			return true;
		}
		if (!this.isRoomExit()) {
			if (!this.booked) {
				if (!this.hasTorch()) {
					if (!this.isChest()) {
						if (!this.isColumn()) {
							if (!this.isSpike()) {
								if (!this.mobGenerated) {
									return true;
								}
							}
						}
					}
				}
			}
		}
		return false;
	}

	canWalk(mob = null) {
		if (this.isBlocked()) {
			return false;
		}
		if (this.isWall()) {
			return false;
		}
		if (this.column > 0) {
			return false;
		}
		// Porte 
		let lStandard = false;
		if (mob) {
			if (mob.canOpenDoors()) {
				//	lStandard = true;
			}
		} else {
			lStandard = true;
		}
		if (mob) {
			if (mob.clas === "hero") {
				lStandard = true;
			}
		}


		if (!lStandard) {

			if (this.end) {
				// I mob non possono uscire
				return false;
			}
			if (mob.canOpenDoors()) {
				// Il mob può aprire la porta
				if (this.isRoomExit()) {
					if (!this.isSecretExit()) {
						if (this.isLockedDoor()) {
							return false;
						}
					}
				}
			} else {
				// Il mob non può aprire la porta
				if (this.isRoomExit()) {
					if (this.mobGenerated.closed) {
						return false;
					}
				}
			}
			if (this.isSpike()) {
				if (mob.canOpenDoors()) {
					return false;
				}
			}

		} else {
			if (this.isRoomExit()) {
				if (!this.isSecretExit()) {
					if (this.isLockedDoor()) {
						return false;
					}
				}
			}
		}

		return true;
	}

	get tiles() {
		return this._tiles;
	}

	openDoor() {
		if (this.mobGenerated.closed) {
			this.mobGenerated.closed = false;
			this.mobGenerated.setAnimation("open");
		}
	}

	closeDoor() {
		if (!this.mobGenerated.closed) {
			this.mobGenerated.closed = true;
			this.mobGenerated.setAnimation("close");
		}
	}

	showSprite(cell, tileIndex, target) {
		this.cellRender.showSprite(cell, tileIndex, target);
	}

	hideSprite(cell, tileIndex, target) {
		this.cellRender.hideSprite(cell, tileIndex, target);
	}

	activateTilesAnimations(lFlag) {
		let a = this.animatedTiles;
		for (let x = 0; x < a.length; x++) {
			//console.log(a[x]);
			a[x].activateAnimation(lFlag);
		}
	}

	dropBuilder() {
		this.blocked = true;
		this.cellRender.dropBuilder(this);
	}

	removeSprite(tileIndex, target) {
		this.cellRender.removeSprite(tileIndex, target);
	}

	setFurniture(sprite,lUpper) {
		this.furniture = sprite;
		this.furnitureUpper = lUpper;
	}



}

Cell.IDS = 0;
Cell.ENUM = 0;
Cell.TYPE_EMPTY = 0;
Cell.TYPE_WALL = 1;



